export const partnerLogsSagaActionTypes = {
  callGetPartnerLogsSaga: "callGetPartnerLogsSaga",
};

export const getPartnerLogsSagaAction: (partnerId: number) => {
  type: string;
  partnerId: number;
} = (partnerId) => {
  return {
    type: partnerLogsSagaActionTypes.callGetPartnerLogsSaga,
    partnerId,
  };
};
